// Helpers to surface relevant blog guides for the homepage strip and contextual
// "Related guides" strips. The heavy 1,700+ entry journal index (blogMeta.js)
// lazy-loads on first use so it stays OUT of the main JS bundle.

let journalPromise = null;
const loadJournal = () => {
  if (!journalPromise) journalPromise = import("./journalData").then((m) => m.JOURNAL);
  return journalPromise;
};

// Return up to `count` guides whose slug/title/category match any of the tokens.
export async function getRelatedGuides(tokens, count = 8, excludeSlug) {
  const JOURNAL = await loadJournal();
  const toks = (tokens || []).map((t) => String(t).toLowerCase().trim()).filter(Boolean);
  if (!toks.length) return [];
  const scored = [];
  for (const p of JOURNAL) {
    if (!p.slug || p.slug === excludeSlug) continue;
    const hay = `${p.slug} ${p.title} ${p.category}`.toLowerCase();
    let score = 0;
    for (const t of toks) if (hay.includes(t)) score += 1;
    if (score > 0) scored.push([score, p]);
  }
  scored.sort((a, b) => b[0] - a[0]);
  return scored.slice(0, count).map((x) => x[1]);
}

// A varied, on-brand set for the homepage "Stories & Food Guides" strip.
export async function getFeaturedGuides(count = 6) {
  const JOURNAL = await loadJournal();
  const cats = ["Food", "Destinations", "Best Time", "Itineraries"];
  const out = [];
  const perCat = Math.max(1, Math.ceil(count / cats.length));
  for (const c of cats) {
    out.push(...JOURNAL.filter((p) => p.category === c && p.slug).slice(0, perCat));
  }
  if (out.length < count) {
    for (const p of JOURNAL) {
      if (p.slug && !out.includes(p)) out.push(p);
      if (out.length >= count) break;
    }
  }
  return out.slice(0, count);
}
